import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewLoginWidgetComponent } from './new-login-widget.component';
import { PreLoginGuard } from '@mem-shared/pre-login.guard';
import { LogoutComponent } from './logout/logout.component';
import { NewLoginWidgetSuccessComponent } from './new-login-widget-success/new-login-widget-success.component';
import { LogoutredirectComponent } from './logoutredirect/logoutredirect.component';

const routes: Routes = [
  {
    path: 'login',
    component: NewLoginWidgetComponent,
    canActivate: [PreLoginGuard],
    data: {
      browserTitle: 'Login'
    },
  },
  {
    path: 'login/:errorMsg',
    component: NewLoginWidgetComponent,
    canActivate: [PreLoginGuard],
    data: {
      browserTitle: 'Login'
    }
  },
  {
    path: 'login/:zapp/:zipenv',
    component: NewLoginWidgetComponent,
    canActivate: [PreLoginGuard],
    data: {
      browserTitle: 'Login'
    },
   },
   {
    // see login-redirects.ts for explanation on this route
    path: 'login/:customRedirect',
    component: NewLoginWidgetComponent,
    canActivate: [PreLoginGuard],
    data: {
      browserTitle: 'Login'
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      browserTitle: 'Logout'
    }
  },
  {
    path: 'logout/:ebiz',
    component: LogoutComponent,
    data: {
      browserTitle: 'Logout'
    }
  },
  {
    path: 'logoutredirect',
    component: LogoutredirectComponent,
    data: {
      browserTitle : 'Logout'
    }
  },
  {
    path: 'accountRecovery/success',
    component: NewLoginWidgetSuccessComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewLoginWidgetRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget-routing.module.ts